export default __webpack_public_path__ + "static/media/portada_ChiaraCarucci.4f1a53a0.jpg";